import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const container = document.getElementById('root') as HTMLElement;

// scripts/prerender.js stamps data-prerendered on <html> and ships real markup
// inside #root. Hydrate that instead of throwing it away and re-rendering, so
// the prerendered content stays on screen (no flash) and stays crawlable.
if (document.documentElement.dataset.prerendered === 'true') {
	ReactDOM.hydrateRoot(container, <App />);
} else {
	ReactDOM.createRoot(container).render(<App />);
}
